import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Camera from "@material-ui/icons/Camera";
import Palette from "@material-ui/icons/Palette";
import Favorite from "@material-ui/icons/Favorite";
// React icons
import { FaTwitter, FaBalanceScaleRight, FaCouch, FaBrain } from 'react-icons/fa';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Button from "components/CustomButtons/Button.jsx";

import loadable from '@loadable/component'


import studio1 from "assets/img/examples/studio-1.jpg";
import studio2 from "assets/img/examples/studio-2.jpg";
import studio3 from "assets/img/examples/studio-3.jpg";
import studio4 from "assets/img/examples/studio-4.jpg";
import studio5 from "assets/img/examples/studio-5.jpg";
import work1 from "assets/img/examples/olu-eletu.jpg";
import work2 from "assets/img/examples/clem-onojeghuo.jpg";
import work3 from "assets/img/examples/cynthia-del-rio.jpg";
import work4 from "assets/img/examples/mariya-georgieva.jpg";
import work5 from "assets/img/examples/clem-onojegaw.jpg";

import firebase from "gatsby-plugin-firebase"
import "firebase/auth";
import "firebase/database"

const style = {
    background: 'linear-gradient(45deg, #50FF50 30%, #00D700 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  };

export default function MemberShowcase(props) {
    const [progress, setProgress] = React.useState(props);

    const dev =  true;
    const CheckinModal = loadable(() => import('./CheckinM'))

    const deleteAccount = () => {
        firebase.auth().currentUser.delete();
      }

    React.useEffect(() => {
        
    }, []);

    const { classes, approved, uid, user, ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );


    const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);

    if(!approved){
        return (
            <>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={8} className={classes.navWrapper}>
                        <h3>You will be notified once your ID has been verified!</h3>
                        <p>Please be patient during this proccess..</p>
                        
                    </GridItem>
                </GridContainer>
            </>
        );
        }else if(dev){
        return (
            <>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={8} className={classes.navWrapper}>
                        <h3>Thank you for completing your profile. Watch this space for exciting news!</h3>
                        <CheckinModal uid={uid} displayName={user.firstName} />
                    </GridItem>
                </GridContainer>
            </>
        );
    }


    return (
        <>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8} className={classes.navWrapper}>
                    <NavPills
                        alignCenter
                        color="primary"
                        tabs={[
                            {
                                tabButton: "Indica",
                                tabIcon: FaCouch,
                                tabContent: (
                                    <GridContainer justify="center">
                                        <GridItem xs={12} sm={12} md={4}>
                                            <img
                                                alt="..."
                                                src={studio1}
                                                className={navImageClasses}
                                            />
                                            <img
                                                alt="..."
                                                src={studio2}
                                                className={navImageClasses}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <img
                                                alt="..."
                                                src={studio5}
                                                className={navImageClasses}
                                            />
                                            <img
                                                alt="..."
                                                src={studio4}
                                                className={navImageClasses}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                )
                            },
                            {
                                tabButton: "Sativa",
                                tabIcon: FaBrain,
                                tabContent: (
                                    <GridContainer justify="center">
                                        <GridItem xs={12} sm={12} md={4}>
                                            <img
                                                alt="..."
                                                src={work1}
                                                className={navImageClasses}
                                            />
                                            <img
                                                alt="..."
                                                src={work2}
                                                className={navImageClasses}
                                            />
                                            <img
                                                alt="..."
                                                src={work3}
                                                className={navImageClasses}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <img
                                                alt="..."
                                                src={work4}
                                                className={navImageClasses}
                                            />
                                            <img
                                                alt="..."
                                                src={work5}
                                                className={navImageClasses}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                )
                            },
                            {
                                tabButton: "Hybrid",
                                tabIcon: FaBalanceScaleRight,
                                tabContent: (
                                    <GridContainer justify="center">
                                        <GridItem xs={12} sm={12} md={4}>
                                            <img
                                                alt="..."
                                                src={work4}
                                                className={navImageClasses}
                                            />
                                            <img
                                                alt="..."
                                                src={studio3}
                                                className={navImageClasses}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <img
                                                alt="..."
                                                src={work2}
                                                className={navImageClasses}
                                            />
                                            <img
                                                alt="..."
                                                src={work1}
                                                className={navImageClasses}
                                            />
                                            <img
                                                alt="..."
                                                src={studio1}
                                                className={navImageClasses}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                )
                            }
                        ]}
                    />
                </GridItem>
            </GridContainer>
        </>
    );
}
